import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { register } from './shared/utils/serviceWorkerRegistration';
import { AuthProvider } from 'react-oidc-context';
import { buildMomentAuthConfig } from '@moment-golf/auth';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <AuthProvider {...buildMomentAuthConfig({
    authority: process.env.REACT_APP_COGNITO_AUTHORITY ?? '',
    clientId: process.env.REACT_APP_COGNITO_CLIENT_ID ?? '',
    cognitoDomain: process.env.REACT_APP_COGNITO_DOMAIN ?? '',
    redirectUri: window.location.origin,
  })}>
    <App />
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
register();
